import React from 'react';
import { Label, Radio, useTreatmentFormAddon } from '@futurefamily/ef-components';
import { formatCurrency } from '@futurefamily/ef-utils';
import { treatments } from 'constants/treatments';

function Addons () {
  const { selectedTreatment, addOnTreatments } = useTreatmentFormAddon(treatments);

  if (!selectedTreatment || !addOnTreatments.length) { return null; }

  return (
    <>
      {addOnTreatments.map(treatment => (
        <div className="row mb-3" key={treatment.value}>
          <Label className="col-6 col-md-8 font-weight-bold">Would you like to include {treatment.name} (${formatCurrency(treatment.cost)})?</Label>
          <div role="group" className="col-6 col-md-4 text-end">
            <Label htmlFor={`addons-${treatment.value}-yes`} className="me-3 d-inline-flex align-items-center">
              YES&nbsp;&nbsp;<Radio id={`addons-${treatment.value}-yes`} name={`addons[${treatment.value}]`} value={'true'} />
            </Label>
            <Label htmlFor={`addons-${treatment.value}-no`} className="d-inline-flex align-items-center">
              NO&nbsp;&nbsp;<Radio id={`addons-${treatment.value}-no`} name={`addons[${treatment.value}]`} value={'false'} />
            </Label>
          </div>
        </div>
      ))}
    </>
  );
}

export default Addons;
